/** Smoothly scroll to a section by id; no-op if the element doesn't exist. */
export function scrollToSection(id: string): void {
  document.getElementById(id)?.scrollIntoView({ block: 'start', behavior: 'smooth' });
}

/** Convenience: scroll to the reserve / CTA section. */
export const scrollToReserve = (): void => scrollToSection('reserve');
export const scrollToDemo = (): void => scrollToSection('demo');